import { HostActions, CDL_V3_EVENT } from '@makemydeal/dr-activities-change-vehicle';
import * as navigationActionCreators from '@makemydeal/dr-dash-store/actions/navigationActionCreators';
import * as openDealV2ActionCreators from '@makemydeal/dr-activities-open-deal-v2';

const forwardCDLEvent = (cdlPayload: any) => ({
    type: CDL_V3_EVENT,
    payload: cdlPayload
});

export const openDealHostActions: HostActions = {
    navigateToDashboard: openDealV2ActionCreators.toggleChangeVehicleEditView,
    // Used switchVehicleHideLoader to dispatch vehicleChangeSuccess action and close the loader
    switchVehicle: openDealV2ActionCreators.switchVehicleHideLoader,
    forwardCDLEvent
};

export const managerViewHostActions: HostActions = {
    navigateToDashboard: navigationActionCreators.navigateToDashboard,
    switchVehicle: () => ({ type: 'UNKNOWN' }),
    forwardCDLEvent
};
